// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__tableBox--TnQWO {
  flex: 1;
  min-width: 50%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__tableHeader--RMwyN {
  display: grid;
  overflow: hidden;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__tableBody--gG5cU {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cellTop--gB4G2 {
  border-top: thin solid #e1e3e6;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cellLeft--UY2OO {
  border-left: thin solid #e1e3e6;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cell--gx9Iw {
  border-right: thin solid #e1e3e6;
  border-bottom: thin solid #e1e3e6;
  min-width: 60px;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cellRow--qui31 {
  color: #343a41;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  overflow: hidden;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__baseSizeCell--TfLQs {
  background-color: #eff5ff;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cellHd--h6d2m {
  color: #767c84;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cellCentered--aNSCK {
  text-align: center;
  padding-top: 4px;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__pad--NnRl1 {
  padding: 8px;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__fullCentered--s8WSs {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cell--gx9Iw .ant-input-number {
  background: none;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__button--Nfg04 {
  visibility: hidden;
  position: absolute;
  right: 0;
  top: calc(50% - 10px);
  transition: visibility 0.2s ease-in-out;
  background-color: white;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__subtitle--urIvN {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__subtitle--urIvN:hover .src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__button--Nfg04 {
  visibility: visible;
}
.src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__text--3yHJZ {
  padding: 8px;
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart/MChartEntity/EditMCEntity/MChartTable/MChartTable.module.less","webpack://./src/businessServices/services/bsMeasurementChart/MChartEntity/EditMCEntity/MChartTable/MCSubtitle.module.less"],"names":[],"mappings":"AAEA;EACE,OAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;ACDF;ADIA;EACE,aAAA;EACA,gBAAA;ACFF;ADIA;EACE,OAAA;EACA,cAAA;ACFF;ADKA;EACE,8BAAA;ACHF;ADKA;EACE,+BAAA;ACHF;ADMA;EACE,gCAAA;EACA,iCAAA;EACA,eAAA;ACJF;ADOA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;ACLF;ADOA;EACE,yBAAA;ACLF;ADQA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ACNF;ADQA;EACE,kBAAA;EACA,gBAAA;ACNF;ADQA;EACE,YAAA;ACNF;ADSA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ACPF;ADWA;EACE,gBAAA;ACTF;AA1DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,uCAAA;EACA,uBAAA;AA4DF;AA1DA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AA4DF;AA3DE;EACE,mBAAA;AA6DJ;AA1DA;EDqCE,YAAA;ECnCA,OAAA;AA4DF","sourcesContent":["@border: thin solid #e1e3e6;\n\n.tableBox {\n  flex: 1;\n  min-width: 50%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.tableHeader {\n  display: grid;\n  overflow: hidden;\n}\n.tableBody {\n  flex: 1;\n  overflow: auto;\n}\n\n.cellTop {\n  border-top: @border;\n}\n.cellLeft {\n  border-left: @border;\n}\n\n.cell {\n  border-right: @border;\n  border-bottom: @border;\n  min-width: 60px;\n}\n\n.cellRow {\n  color: #343a41;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  overflow: hidden;\n}\n.baseSizeCell {\n  background-color: #eff5ff;\n}\n\n.cellHd {\n  color: #767c84;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.cellCentered {\n  text-align: center;\n  padding-top: 4px;\n}\n.pad {\n  padding: 8px;\n}\n\n.fullCentered {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n// Иначе активный столбец подсвечивает тользо заголовок\n.cell :global(.ant-input-number) {\n  background: none;\n}\n","@import \"./MChartTable.module.less\";\n\n.button {\n  visibility: hidden;\n  position: absolute;\n  right: 0;\n  top: calc(50% - 10px);\n  transition: visibility 0.2s ease-in-out;\n  background-color: white;\n}\n.subtitle {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  &:hover .button {\n    visibility: visible;\n  }\n}\n.text {\n  .pad();\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableBox": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__tableBox--TnQWO`,
	"tableHeader": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__tableHeader--RMwyN`,
	"tableBody": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__tableBody--gG5cU`,
	"cellTop": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cellTop--gB4G2`,
	"cellLeft": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cellLeft--UY2OO`,
	"cell": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cell--gx9Iw`,
	"cellRow": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cellRow--qui31`,
	"baseSizeCell": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__baseSizeCell--TfLQs`,
	"cellHd": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cellHd--h6d2m`,
	"cellCentered": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__cellCentered--aNSCK`,
	"pad": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__pad--NnRl1`,
	"fullCentered": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__fullCentered--s8WSs`,
	"button": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__button--Nfg04`,
	"subtitle": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__subtitle--urIvN`,
	"text": `src-businessServices-services-bsMeasurementChart-MChartEntity-EditMCEntity-MChartTable-MCSubtitle-module__text--3yHJZ`
};
export default ___CSS_LOADER_EXPORT___;
